import { AnswerSubCategoryDetail } from "@/schema/app/assessment/answerSubCategoryDetail";
import { useFieldArray, useFormContext } from "react-hook-form";
import Question from "./Question";

function SubCategory() {
  const { control } = useFormContext<AnswerSubCategoryDetail>();
  const { fields } = useFieldArray({
    control,
    name: `answer_contents`,
  });

  return (
    <div>
      <div className="my-card mt-8">
        {fields.map((question, index) => (
          <div key={question.id}>
            <Question index={index} />
            {fields.length - 1 !== index && (
              <div className="h-px bg-cool-gray-200" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SubCategory;
